import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

/**
 * Keeps product badges in sync with the selected variant.
 * Sale/Ale is variant-specific once it is gated on Omnibus promotion data.
 *
 * @extends {Component}
 */
class ProductBadgesComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    const target = this.closest('product-card, .shopify-section, dialog');
    if (!target) return;
    target.addEventListener(ThemeEvents.variantUpdate, this.updateBadges);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const target = this.closest('product-card, .shopify-section, dialog');
    if (!target) return;
    target.removeEventListener(ThemeEvents.variantUpdate, this.updateBadges);
  }

  /**
   * @param {VariantUpdateEvent} event
   */
  updateBadges = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId &&
      this.dataset.productId &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const selector = this.dataset.blockId
      ? `product-badges-component[data-block-id="${this.dataset.blockId}"]`
      : 'product-badges-component';
    const newBadges = event.detail.data.html.querySelector(selector);
    if (!newBadges) return;

    morph(this, newBadges, { childrenOnly: true });
  };
}

if (!customElements.get('product-badges-component')) {
  customElements.define('product-badges-component', ProductBadgesComponent);
}
